import type { Novidade } from './tipos';

/** Fase 2 (W6): catálogos de Serviços, Formas e Condições de pagamento, abas projetadas e importação com modelo. */
export const novidadeCatalogos: Novidade = {
  id: '2026-10-05-catalogos',
  publicada_em: '2026-10-05',
  tipo: 'novo',
  modulo: 'cadastros',
  permissao: 'cadastros.ver',
  textos: {
    pt: {
      titulo: 'Serviços, formas e condições de pagamento',
      resumo: 'Novos catálogos em Cadastros e importação com modelo pronto para baixar, que abre certo no Excel.',
      passos: [
        'Em Cadastros, Serviços reúne o que você vende e compra, com preço, custo e tipo de cobrança.',
        'Formas de pagamento guarda o meio com nome livre (Pix Sicredi) e Condições de pagamento, o prazo.',
        'Produtos, Categorias, Centros de custo, Contas e caixas e Recursos também aparecem em Cadastros.',
        'Em cada importação, use Baixar modelo: as colunas já vêm certas, com um exemplo que a importação ignora.',
      ],
    },
    en: {
      titulo: 'Services, payment methods and payment terms',
      resumo: 'New catalogs in Records and imports with a ready template to download, which opens correctly in Excel.',
      passos: [
        'In Records, Services gathers what you sell and buy, with price, cost and billing type.',
        'Payment methods keeps the method with a free name (Pix Sicredi) and Payment terms keeps the due period.',
        'Products, Categories, Cost centers, Accounts and cash and Resources also show up in Records.',
        'In every import, use Download template: the columns come right, with an example row the import ignores.',
      ],
    },
    es: {
      titulo: 'Servicios, formas y condiciones de pago',
      resumo: 'Nuevos catálogos en Registros e importación con plantilla lista para descargar, que se abre bien en Excel.',
      passos: [
        'En Registros, Servicios reúne lo que vendes y compras, con precio, costo y tipo de cobro.',
        'Formas de pago guarda el medio con nombre libre (Pix Sicredi) y Condiciones de pago, el plazo.',
        'Productos, Categorías, Centros de costo, Cuentas y cajas y Recursos también aparecen en Registros.',
        'En cada importación, usa Descargar plantilla: las columnas vienen correctas, con un ejemplo que la importación ignora.',
      ],
    },
  },
  imagens: ['/novidades/2026-10-05-catalogos/servicos.webp', null, null, null],
  treinamento: { curso: 'novidades' },
  rota: '/cadastros/cadastros/servicos',
};
